import ModalDialog from './modal-dialog';

const selectors = {
  showLoginLink: '[data-show-login-form]',
  showRegisterLink: '[data-show-register-form]',
  showRecoverPasswordLink: '[data-show-recover-password-form]',
  loginForm: '[data-login-modal-login-form]',
  registerForm: '[data-login-modal-register-form]',
  recoverPasswordForm: '[data-login-modal-recover-password-form]',
};

function handleShowLoginForm(evt) {
  evt.preventDefault();
  document.querySelector(selectors.loginForm)?.classList.remove('hide');
  document.querySelector(selectors.registerForm)?.classList.add('hide');
  document.querySelector(selectors.recoverPasswordForm)?.classList.add('hide');
}

function handleShowRegisterForm(evt) {
  evt.preventDefault();
  document.querySelector(selectors.loginForm)?.classList.add('hide');
  document.querySelector(selectors.registerForm)?.classList.remove('hide');
  document.querySelector(selectors.recoverPasswordForm)?.classList.add('hide');
}

function handleShowRecoverPasswordForm(evt) {
  evt.preventDefault();
  document.querySelector(selectors.loginForm)?.classList.add('hide');
  document.querySelector(selectors.registerForm)?.classList.add('hide');
  document.querySelector(selectors.recoverPasswordForm)?.classList.remove('hide');
}

export default function initLoginModal() {
  const loginModalEl = document.querySelector('#modal-login');
  const loginModalTriggers = document.querySelectorAll('[data-login-modal-trigger]');

  if (loginModalEl && loginModalTriggers.length > 0) {
    const loginModalFocusEl = loginModalEl.querySelector('#login-modal-email');
    // eslint-disable-next-line no-unused-vars
    const loginModal = new ModalDialog(loginModalEl, {
      toggleEl: loginModalTriggers,
      focusEl: loginModalFocusEl,
      modalId: 'login',
    });

    const showLoginLinks = document.querySelectorAll(selectors.showLoginLink);
    const showRegisterLinks = document.querySelectorAll(selectors.showRegisterLink);
    const showRecoverPasswordLinks = document.querySelectorAll(selectors.showRecoverPasswordLink);
    showLoginLinks.forEach((showLoginLink) => showLoginLink.addEventListener('click', handleShowLoginForm));
    showRegisterLinks.forEach((showRegisterLink) => showRegisterLink.addEventListener('click', handleShowRegisterForm));
    showRecoverPasswordLinks.forEach((showRecoverPasswordLink) =>
      showRecoverPasswordLink.addEventListener('click', handleShowRecoverPasswordForm)
    );
  }
}
